var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _g2, _path10, _g3, _g4, _path11, _g5, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _path17, _path18, _path19, _g8, _path20, _g9, _path21, _path22, _path23, _path24, _g0, _path25, _path26, _g1, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g10, _path36, _path37, _path38, _path39, _g11, _path40, _path41, _g12, _path42, _g13, _path43, _path44, _g14, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g15, _path53, _g16, _path54, _g17, _path55, _g18, _path56, _g19, _path57, _g20, _path58, _g21, _path59, _g22, _path60, _g23, _path61, _g24, _path62, _g25, _path63, _g26, _path64, _g27, _path65, _g28, _path66, _g29, _path67, _g30, _path68, _g31, _path69, _g32, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g33, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g34, _rect, _path117, _path118, _path119, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 437,
    viewBox: "0 0 437 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27827_4655)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456 -164.326H0V548.615H456V-164.326Z",
    fill: "url(#paint0_radial_27827_4655)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0067 149.322C86.0067 144.345 82.4727 140.306 78.1182 140.306C82.4727 140.306 86.0067 136.268 86.0067 131.291C86.0067 136.268 89.5407 140.306 93.8953 140.306C89.5407 140.306 86.0067 144.345 86.0067 149.322Z",
    fill: "#46F7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.733 304.838C327.733 301.727 325.461 299.203 322.662 299.203C325.461 299.203 327.733 296.679 327.733 293.568C327.733 296.679 330.005 299.203 332.805 299.203C330.005 299.203 327.733 301.727 327.733 304.838Z",
    fill: "#46F7B7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27827_4655)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M309.358 261.644C306.929 260.883 301.848 262.923 297.556 261.643L297.661 177.538C297.661 177.009 297.233 176.58 296.704 176.58H295.313C294.575 176.58 294.115 175.782 294.483 175.143L302.732 160.855C302.917 160.536 303.24 160.376 303.562 160.376C303.885 160.376 304.207 160.536 304.392 160.855L312.641 175.143C313.01 175.782 312.549 176.58 311.812 176.58H310.421C309.892 176.58 309.463 177.009 309.463 177.538L309.358 261.644Z",
    fill: "#46F7B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M281.122 254.578C278.692 253.816 273.612 255.856 269.32 254.577L269.425 170.471C269.425 169.942 268.996 169.514 268.467 169.514H267.076C266.339 169.514 265.878 168.715 266.247 168.077L274.496 153.789C274.681 153.469 275.003 153.31 275.326 153.31C275.648 153.31 275.971 153.469 276.155 153.789L284.404 168.077C284.773 168.715 284.312 169.514 283.575 169.514H282.184C281.655 169.514 281.227 169.942 281.227 170.471L281.122 254.578Z",
    fill: "#46F7B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M252.887 240.457C250.458 239.695 245.378 241.735 241.086 240.456L241.191 156.35C241.191 155.821 240.762 155.393 240.233 155.393H238.842C238.105 155.393 237.644 154.594 238.013 153.956L246.262 139.668C246.446 139.348 246.769 139.189 247.091 139.189C247.414 139.189 247.736 139.348 247.921 139.668L256.17 153.956C256.539 154.594 256.078 155.393 255.341 155.393H253.95C253.421 155.393 252.992 155.821 252.992 156.35L252.887 240.457Z",
    fill: "#46F7B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.865 327.205H125.291C125.291 327.205 130.706 330.629 148.009 330.629H307.72C325.022 330.629 330.437 327.205 330.437 327.205H227.863H227.865Z",
    fill: "#202082"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.865 326.064H125.291V327.206H227.865H330.438V326.064H227.865Z",
    fill: "#3232CE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.864 326.064H210.256V327.206C210.256 327.206 211.262 327.777 211.96 327.777H243.769C244.467 327.777 245.473 327.206 245.473 327.206V326.064H227.864Z",
    fill: "#5555FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M311.812 324.268C311.812 324.895 311.71 325.499 311.522 326.065H144.209C144.023 325.502 143.922 324.901 143.922 324.277L143.917 217.903C143.917 214.765 146.472 212.198 149.597 212.198L306.128 212.189C309.251 212.189 311.807 214.756 311.807 217.895L311.812 324.269V324.268Z",
    fill: "#25259E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_27827_4655)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.229 265.994L272.794 237.527C272.059 236.255 270.223 236.255 269.488 237.527L253.052 265.994C252.318 267.267 253.236 268.857 254.705 268.857H257.476C258.53 268.857 259.384 269.712 259.384 270.766V353.222C259.384 354.277 260.239 355.131 261.293 355.131H280.989C282.043 355.131 282.898 354.277 282.898 353.222V270.766C282.898 269.712 283.752 268.857 284.806 268.857H287.577C289.046 268.857 289.964 267.267 289.229 265.994Z",
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 209,
    width: 30,
    height: 76
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M181.678 284.51V235.968C181.678 235.151 180.998 234.471 180.181 234.471H178.004C176.869 234.471 176.144 233.246 176.733 232.248L189.527 210.109C189.799 209.61 190.298 209.338 190.797 209.338C191.296 209.338 191.795 209.61 192.113 210.109L204.906 232.248C205.45 233.246 204.77 234.471 203.59 234.471H201.458C200.641 234.471 199.961 235.151 199.961 235.968V239.733C195.651 241.049 191.886 242.274 191.886 242.274C191.84 242.274 190.933 242.728 190.706 243.635C189.209 250.576 183.538 275.573 181.678 284.51Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.664 284.498V235.96C181.664 235.139 180.999 234.474 180.179 234.474H178.022C176.878 234.474 176.164 233.236 176.735 232.245L189.529 210.087C189.815 209.592 190.315 209.344 190.815 209.344C191.316 209.344 191.816 209.592 192.102 210.087L204.895 232.245C205.467 233.236 204.752 234.474 203.609 234.474H201.452C200.631 234.474 199.966 235.139 199.966 235.96V239.741C195.664 241.061 191.888 242.253 191.888 242.253C191.888 242.253 191.888 242.253 191.889 242.254C191.86 242.267 190.911 242.707 190.711 243.627C189.199 250.578 183.524 275.572 181.664 284.498Z",
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 190,
    width: 19,
    height: 93
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.316 282.556H250.862C250.953 282.193 250.999 281.83 251.044 281.422L251.316 282.556ZM255.535 241.817C253.131 241.046 248.05 239.458 243.74 238.188V207.747C243.74 207.202 243.286 206.794 242.787 206.794H241.381C240.655 206.794 240.201 205.977 240.564 205.342L248.821 191.052C249.002 190.734 249.32 190.553 249.638 190.553C249.955 190.553 250.273 190.734 250.454 191.052L258.711 205.342C259.074 205.977 258.62 206.794 257.894 206.794H256.488C255.989 206.794 255.535 207.202 255.535 207.747V241.817Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.328 282.576H250.882C250.933 282.2 250.986 281.819 251.039 281.435C251.039 281.436 251.039 281.437 251.039 281.437L251.328 282.576ZM255.539 241.802C253.11 241.04 248.03 239.457 243.737 238.177V207.731C243.737 207.202 243.309 206.773 242.78 206.773H241.389C240.652 206.773 240.191 205.974 240.56 205.336L248.809 191.048C248.993 190.729 249.316 190.569 249.638 190.569C249.961 190.569 250.283 190.729 250.468 191.048L258.717 205.336C259.086 205.974 258.625 206.773 257.888 206.773H256.497C255.968 206.773 255.539 207.202 255.539 207.731V241.802Z",
    fill: "#46F7B7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.187 240.93H234.965L246.281 330.266C246.281 330.266 210.699 333.854 205.332 327.342C199.966 320.832 209.187 240.93 209.187 240.93Z",
    fill: "#CBD2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.811 368.002H250.125V323.222H199.811V368.002Z",
    fill: "#29273F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.811 323.225H250.125V319.304H199.811V323.225Z",
    fill: "#1E1D30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 239,
    width: 7,
    height: 8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.138 246.038H222.962C222.009 244.36 221.737 242.227 221.828 239.959H227.317C227.68 242.318 227.453 244.405 226.138 246.038Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.134 246.053H222.984C222.029 244.347 221.744 242.249 221.818 239.941H227.301C227.684 242.31 227.439 244.409 226.134 246.053Z",
    fill: "url(#paint1_radial_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 246,
    width: 5,
    height: 39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.776 284.644L224.277 284.508C223.869 276.932 223.052 269.038 222.1 261.689L222.962 246.037H226.137L226.954 260.146C226.046 267.45 225.23 275.752 224.776 284.644Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.789 284.639L224.268 284.505C223.851 276.95 223.034 269.039 222.095 261.671L222.983 246.053H226.133L226.936 260.158C226.038 267.475 225.243 275.774 224.789 284.639Z",
    fill: "url(#paint2_radial_27827_4655)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.476 300.062C225.41 301.922 231.694 339.254 231.694 339.254C238.126 347.795 256.455 343.458 256.039 334.648C256.039 334.648 248.727 304.174 249.506 294.075C249.625 292.525 249.881 290.235 250.234 287.465C251.298 279.08 253.22 266.306 254.742 256.473C255.992 248.362 256.972 242.252 256.972 242.252C256.972 242.252 246.316 238.887 240.406 237.202C234.494 235.52 231.694 230.914 231.694 230.914C226.407 255.54 223.543 298.202 224.476 300.062Z",
    fill: "#363151"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 225,
    width: 8,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.718 230.93V225.939L224.414 228.344V240.048L228.497 237.871L231.718 230.93Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.529 231.493V226.023L223.765 228.66V241.553L228.12 239.16L231.529 231.493Z",
    fill: "url(#paint3_linear_27827_4655)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.389 299.217L238.762 246.053L235.69 244.559L240.65 240.042L239.765 236.686C239.765 236.686 233.86 234.195 231.694 230.209C231.694 230.209 231.712 230.962 231.618 231.427C230.318 237.879 224.471 266.396 224.389 299.217Z",
    fill: "#29273F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M231.694 230.916C229.156 234.896 228.441 237.955 224.433 240.04C224.433 240.04 227.262 242.166 230.528 247.659C231.876 248.108 234.515 234.734 231.694 230.916Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250.234 287.471C251.298 279.086 253.22 266.311 254.742 256.478C254.466 256.879 254.994 247.648 254.742 248.105C248.533 259.32 249.37 282.616 250.234 287.471Z",
    fill: "#29273F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.971 242.254C256.971 242.254 257.946 242.694 258.15 243.628C259.901 251.679 267.239 286.372 267.761 289.826C268.345 293.679 262.415 339.783 262.415 339.783C258.527 338.121 255.179 335.443 252.383 331.727L254.812 296.337L251.038 281.438C251.038 281.438 250.127 254.568 256.971 242.254Z",
    fill: "#363151"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 209,
    width: 5,
    height: 13
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M216.339 215.19C216.339 218.457 215.432 221.088 214.298 221.088C213.164 221.088 212.211 218.457 212.211 215.19C212.211 211.969 213.164 209.338 214.298 209.338C215.432 209.338 216.339 211.969 216.339 215.19Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.342 215.209C216.342 218.447 215.42 221.072 214.282 221.072C213.145 221.072 212.223 218.447 212.223 215.209C212.223 211.971 213.145 209.345 214.282 209.345C215.42 209.345 216.342 211.971 216.342 215.209Z",
    fill: "url(#paint4_linear_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 209,
    width: 5,
    height: 13
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.889 215.19C236.889 218.457 235.936 221.088 234.802 221.088C233.668 221.088 232.761 218.457 232.761 215.19C232.761 211.969 233.668 209.338 234.802 209.338C235.936 209.338 236.889 211.969 236.889 215.19Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.873 215.209C236.873 218.447 235.951 221.072 234.814 221.072C233.676 221.072 232.754 218.447 232.754 215.209C232.754 211.971 233.676 209.345 234.814 209.345C235.951 209.345 236.873 211.971 236.873 215.209Z",
    fill: "url(#paint5_linear_27827_4655)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.634 200.311C212.634 200.311 210.664 206.445 210.973 209.28C211.284 212.115 213.985 217.74 213.985 217.74L214.736 200.743L212.634 200.311Z",
    fill: "#363151"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.878 200.444C234.878 200.444 237.97 198.384 238.9 202.836C239.83 207.287 235.19 217.74 235.19 217.74H234.183L232.354 201.551L234.878 200.444Z",
    fill: "#363151"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.384 300.062C223.45 301.922 217.166 339.254 217.166 339.254C210.734 347.795 192.404 343.458 192.821 334.648C192.821 334.648 200.134 304.174 199.354 294.075C199.235 292.525 198.978 290.235 198.626 287.465C197.563 279.08 195.64 266.306 194.118 256.473C192.868 248.362 191.888 242.252 191.888 242.252C191.888 242.252 202.544 238.887 208.454 237.202C214.366 235.52 217.166 230.914 217.166 230.914C222.453 255.54 225.317 298.202 224.384 300.062Z",
    fill: "#363151"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 225,
    width: 8,
    height: 16
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.155 230.93V225.939L224.414 228.344V240.048L220.376 237.871L217.155 230.93Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.166 230.916V225.956L224.428 228.347V240.041L220.355 237.871L217.166 230.916Z",
    fill: "url(#paint6_linear_27827_4655)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M217.412 231.32V228.85H230.471C229.647 230.261 227.294 233.297 224.471 234.144C221.647 234.991 218.589 232.614 217.412 231.32Z",
    fill: "#D4A790"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 199,
    width: 23,
    height: 34
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M234.621 199.268L235.211 221.815C235.211 223.448 234.621 225.036 233.578 226.306L230.266 230.298C229.314 231.432 227.907 232.113 226.41 232.113H222.418C220.966 232.113 219.56 231.432 218.607 230.298L215.295 226.306C214.252 225.036 213.662 223.448 213.662 221.815L214.297 199.631L234.621 199.268Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.602 199.246L235.191 221.832C235.191 223.466 234.62 225.049 233.577 226.307L230.262 230.307C229.315 231.45 227.907 232.111 226.422 232.111H222.433C220.948 232.111 219.54 231.45 218.593 230.307L215.278 226.307C214.235 225.049 213.664 223.466 213.664 221.832L214.282 199.622L234.602 199.246Z",
    fill: "url(#paint7_linear_27827_4655)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209.689 198.172C209.689 198.172 212.461 206.245 223.053 206.687C233.644 207.131 235.023 205.369 236.685 202.977C238.346 200.586 233.63 195.691 227.85 194.363C222.069 193.034 214.606 199.168 209.689 198.172Z",
    fill: "#363151"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.472 299.217L210.098 246.053L213.17 244.559L208.21 240.042L209.095 236.686C209.095 236.686 215 234.195 217.166 230.209C217.166 230.209 217.148 230.962 217.242 231.427C218.543 237.879 225.423 275.024 224.472 299.217Z",
    fill: "#29273F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M217.166 230.915C219.705 234.896 220.42 237.955 224.428 240.04C224.428 240.04 221.599 242.166 218.333 247.658C217.748 247.658 215.512 234.104 217.166 230.915Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.627 287.471C197.563 279.086 195.641 266.311 194.119 256.478C194.257 256.678 194.194 254.484 194.129 252.289C194.062 250.083 193.993 247.876 194.119 248.105C200.328 259.32 199.49 282.616 198.627 287.471Z",
    fill: "#29273F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.889 242.254C191.889 242.254 190.914 242.694 190.711 243.628C188.959 251.679 181.622 283.943 181.099 287.396C180.516 291.249 186.445 339.783 186.445 339.783C190.332 338.121 193.681 335.443 196.478 331.727L194.048 293.907L197.822 281.438C197.822 281.438 198.733 254.568 191.889 242.254Z",
    fill: "#363151"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.881 307.862L215.986 311.215C216.107 311.246 216.212 311.32 216.283 311.422L216.414 311.611L202.652 308.869C202.262 308.791 202.102 308.319 202.366 308.021C202.494 307.875 202.694 307.814 202.881 307.862Z",
    fill: "#29273F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M247.081 307.862L233.977 311.215C233.856 311.246 233.751 311.32 233.68 311.422L233.549 311.611L247.31 308.869C247.7 308.791 247.86 308.319 247.597 308.021C247.468 307.875 247.269 307.814 247.081 307.862Z",
    fill: "#29273F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M224.674 226.939H224.395C222.673 226.939 221.277 225.543 221.277 223.821H227.792C227.792 225.543 226.396 226.939 224.674 226.939Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 309,
    width: 4,
    height: 4
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M151.282 312.091C150.965 311.819 150.783 311.456 150.783 311.047C150.783 310.231 151.418 309.596 152.235 309.596C152.598 309.596 152.961 309.777 153.233 310.004L152.053 310.866L151.282 312.091Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.265 312.1C150.975 311.838 150.793 311.459 150.793 311.038C150.793 310.247 151.434 309.606 152.224 309.606C152.619 309.606 152.976 309.766 153.235 310.025L152.056 310.878L151.265 312.1Z",
    fill: "#03C4DE"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.287 278.096L199.218 278.078C199.22 277.892 199.221 277.705 199.221 277.517C199.268 277.657 199.293 277.808 199.293 277.964C199.293 278.009 199.291 278.052 199.287 278.096Z",
    fill: "#55B9F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.218 278.076L197.861 277.728C197.86 277.353 197.857 276.952 197.853 276.531C197.856 276.531 197.859 276.531 197.862 276.531C198.496 276.531 199.034 276.944 199.222 277.515C199.221 277.703 199.22 277.891 199.218 278.076Z",
    fill: "#03C4DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M196.585 278.607C196.487 278.413 196.432 278.194 196.432 277.962C196.432 277.175 197.067 276.536 197.853 276.531C197.858 276.952 197.86 277.352 197.862 277.727L197.816 277.716L196.585 278.607Z",
    fill: "#03C4DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 289,
    width: 2,
    height: 2
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.818 290.724C249.864 290.497 249.909 290.27 249.909 289.998C250.091 290.043 250.227 290.134 250.363 290.225L249.818 290.724Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.839 290.725C249.865 290.495 249.892 290.259 249.921 290.017C250.078 290.054 250.225 290.119 250.354 290.208L249.839 290.725Z",
    fill: "#03C4DE"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M249.569 290.994L248.491 290.717C248.691 290.284 249.129 289.984 249.638 289.984C249.735 289.984 249.83 289.995 249.921 290.016C249.893 290.257 249.865 290.493 249.839 290.723L249.569 290.994Z",
    fill: "#03C4DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 243,
    width: 4,
    height: 3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294.958 245.537C294.777 245.31 294.731 245.083 294.731 244.811C294.731 244.131 295.276 243.541 295.956 243.541C296.455 243.541 296.864 243.813 297.091 244.176L295.866 244.63L294.958 245.537Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.936 245.537C294.795 245.333 294.712 245.086 294.712 244.819C294.712 244.121 295.277 243.556 295.974 243.556C296.444 243.556 296.854 243.813 297.071 244.194L295.85 244.622L294.936 245.537Z",
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 239,
    width: 180,
    height: 106
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.278 344.938H130.006L151.283 312.093L152.054 310.868L153.233 310.006L181.088 289.818C181.134 289.908 181.134 289.999 181.134 290.09L152.235 311.049L130.278 344.938ZM249.819 291.088C249.819 290.952 249.819 290.861 249.819 290.725L250.363 290.226L252.677 287.867L252.722 288.139L249.819 291.088ZM283.934 256.882L283.843 256.655L294.958 245.54L295.866 244.633L297.09 244.179L309.43 239.869V240.096L295.956 244.814L283.934 256.882Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.27 344.92H130L151.265 312.096L152.056 310.875L153.235 310.021L181.108 289.822C181.112 289.91 181.117 289.999 181.122 290.091L152.224 311.034L130.27 344.92ZM249.798 291.084C249.811 290.965 249.825 290.845 249.839 290.722L250.354 290.206L252.671 287.884L252.736 288.14L249.798 291.084ZM283.955 256.859L283.837 256.656L294.936 245.534L295.85 244.619L297.071 244.192L309.43 239.869V240.11L295.974 244.816L283.955 256.859Z",
    fill: "#55B9F5"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M264.967 275.885C264.949 275.797 264.931 275.707 264.912 275.619L283.838 256.656L283.955 256.859L264.967 275.885Z",
    fill: "#53ABDF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 284,
    width: 1,
    height: 1
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M224.776 284.869L224.277 284.733C224.277 284.642 224.277 284.597 224.277 284.506L224.776 284.642C224.776 284.733 224.776 284.778 224.776 284.869Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_27827_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.777 284.869L224.28 284.742C224.276 284.663 224.272 284.583 224.268 284.504L224.788 284.638C224.784 284.716 224.78 284.792 224.777 284.869Z",
    fill: "#55B9F5"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M249.638 291.248L228.042 285.707L228.101 285.488L248.492 290.72L249.569 290.996L249.84 290.725C249.826 290.847 249.812 290.968 249.799 291.087L249.638 291.248Z",
    fill: "#55B9F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M228.042 285.709L224.777 284.871C224.781 284.793 224.785 284.718 224.789 284.64L228.101 285.49L228.042 285.709Z",
    fill: "#55B9F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M252.737 288.143L252.672 287.886L264.912 275.621C264.931 275.709 264.949 275.799 264.968 275.887L252.737 288.143Z",
    fill: "#55B9F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M220.281 283.713L199.216 278.308C199.217 278.231 199.218 278.152 199.218 278.075L199.288 278.092L220.213 283.462L220.281 283.713Z",
    fill: "#55B9F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M224.281 284.74L220.281 283.714L220.213 283.462L224.268 284.503C224.272 284.581 224.277 284.661 224.281 284.74Z",
    fill: "#55B9F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M199.216 278.311L197.862 277.963C197.862 277.886 197.862 277.808 197.861 277.728L199.218 278.077C199.218 278.154 199.217 278.233 199.216 278.311Z",
    fill: "#55B9F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M181.122 290.096C181.117 290.003 181.113 289.915 181.108 289.826L196.585 278.61L197.816 277.718L197.861 277.73C197.862 277.81 197.862 277.888 197.862 277.965L181.122 290.096Z",
    fill: "#55B9F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 259,
    y: 257,
    width: 31,
    height: 88
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M282.891 344.935H259.392V338.221C260.344 338.811 261.388 339.355 262.431 339.764C262.431 339.764 268.329 293.671 267.784 289.815C267.558 288.545 266.469 283.01 265.017 276.16L284.071 257.061L289.243 265.998C289.969 267.268 289.061 268.856 287.564 268.856H284.797C283.753 268.856 282.891 269.718 282.891 270.761V344.935Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.979,
    y: 256.604,
    width: 31.4027,
    height: 88.7005,
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 281,
    width: 19,
    height: 64
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M199.825 344.937H199.78C199.78 344.891 199.825 344.891 199.825 344.891V344.937ZM193.701 344.937H181.679V296.939C183.085 312.182 186.442 339.765 186.442 339.765C187.894 339.175 189.255 338.404 190.525 337.542C190.933 339.493 191.841 342.714 193.701 344.937ZM195.788 321.074L194.064 293.9L197.829 281.424C198.101 283.601 198.374 285.643 198.646 287.458C198.963 290.225 199.236 292.539 199.372 294.081C199.78 299.707 197.738 311.638 195.788 321.074Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.221,
    y: 281.01,
    width: 19.0176,
    height: 64.2933,
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 301,
    width: 20,
    height: 44
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M172.197 344.935H160.13V319.258C160.13 318.714 159.676 318.305 159.132 318.305H157.725C156.954 318.305 156.5 317.489 156.863 316.808L165.302 302.2C165.483 301.883 165.801 301.701 166.164 301.701C166.481 301.701 166.799 301.883 166.98 302.2L175.418 316.808C175.827 317.489 175.328 318.305 174.602 318.305H173.15C172.606 318.305 172.197 318.714 172.197 319.258V344.935Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.178,
    y: 301.24,
    width: 19.8796,
    height: 44.0599,
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 287,
    y: 286,
    width: 20,
    height: 59
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M303.033 344.936H290.966V303.653C290.966 303.108 290.512 302.654 289.968 302.654H288.561C287.79 302.654 287.336 301.838 287.699 301.203L296.138 286.595C296.319 286.232 296.682 286.096 296.999 286.096C297.317 286.096 297.635 286.232 297.861 286.595L306.3 301.203C306.663 301.838 306.164 302.654 305.438 302.654H304.031C303.487 302.654 303.033 303.108 303.033 303.653V344.936Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.061,
    y: 285.818,
    width: 19.8796,
    height: 59.4845,
    fill: "#46F7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 315,
    width: 9,
    height: 5
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M228.269 319.303H220.603C220.875 317.897 221.102 316.49 221.374 315.084C222.326 316.536 223.506 317.715 224.822 318.486C225.865 317.715 226.772 316.717 227.589 315.538C227.816 316.763 228.043 318.033 228.269 319.303Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.234,
    y: 314.76,
    width: 8.31113,
    height: 4.81792,
    fill: "url(#pattern0_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 323,
    width: 51,
    height: 22
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M249.774 344.94H199.825V344.894C200.188 344.35 200.551 343.715 200.869 343.079C202.638 343.579 204.543 343.896 206.403 343.896C210.577 343.896 214.751 342.49 217.155 339.269C217.155 339.269 218.425 331.693 219.923 323.209H228.95C230.402 331.693 231.672 339.269 231.672 339.269C234.122 342.49 238.251 343.896 242.424 343.896C244.557 343.896 246.689 343.533 248.594 342.853C248.957 343.624 249.365 344.304 249.774 344.94Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.549,
    y: 322.842,
    width: 50.5473,
    height: 22.4655,
    fill: "url(#pattern1_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 319,
    width: 10,
    height: 5
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M228.95 323.208H219.922C220.149 321.938 220.376 320.622 220.602 319.307H228.269C228.496 320.622 228.723 321.938 228.95 323.208Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.555,
    y: 318.893,
    width: 9.62676,
    height: 4.63645,
    fill: "url(#pattern2_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 284,
    width: 7,
    height: 35
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M224.822 318.489C223.506 317.717 222.327 316.538 221.374 315.086C222.735 307.465 224.005 300.841 224.368 300.07C224.414 300.025 224.414 299.979 224.414 299.934C224.459 299.979 224.459 300.025 224.459 300.07C224.867 300.841 226.183 307.737 227.589 315.54C226.773 316.719 225.865 317.717 224.822 318.489ZM224.504 290.861C224.459 288.955 224.414 286.959 224.277 284.963L224.777 285.099C224.686 286.823 224.595 288.547 224.55 290.316C224.55 290.498 224.55 290.679 224.504 290.861Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.098,
    y: 284.732,
    width: 6.76867,
    height: 34.2154,
    fill: "url(#pattern3_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 278,
    width: 3,
    height: 10
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M198.646 287.459C198.373 285.644 198.101 283.603 197.829 281.425C197.829 281.38 197.829 280.654 197.874 279.383C198.464 279.383 198.963 279.021 199.19 278.521L199.235 278.567C199.145 282.695 198.873 285.962 198.646 287.459Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.553,
    y: 278.197,
    width: 2.05057,
    height: 9.62676,
    fill: "url(#pattern4_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 307,
    width: 15,
    height: 5
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M216.429 311.592L202.638 308.87C202.275 308.779 202.093 308.325 202.365 308.008C202.456 307.917 202.592 307.826 202.774 307.826C202.819 307.826 202.819 307.872 202.864 307.872L215.975 311.229C216.111 311.229 216.202 311.319 216.293 311.41L216.429 311.592Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.726,
    y: 307.596,
    width: 15.0707,
    height: 4.36425,
    fill: "url(#pattern5_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 307,
    width: 15,
    height: 5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M233.532 311.592L233.668 311.41C233.759 311.319 233.85 311.229 233.986 311.229L247.097 307.872C247.142 307.872 247.188 307.826 247.188 307.826C247.369 307.826 247.505 307.917 247.596 308.008C247.868 308.325 247.687 308.779 247.324 308.87L233.532 311.592Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.301,
    y: 307.596,
    width: 14.8439,
    height: 4.36425,
    fill: "url(#pattern6_27827_4655)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 310,
    width: 3,
    height: 3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.236 312.452C152.009 312.452 151.828 312.407 151.646 312.361L152.372 311.182L153.506 310.365C153.597 310.592 153.643 310.819 153.643 311.046C153.643 311.817 153.007 312.452 152.236 312.452Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.415,
    y: 309.955,
    width: 2.64034,
    height: 2.91253,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 278,
    width: 3,
    height: 2
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M197.874 279.385C197.874 279.067 197.874 278.659 197.874 278.25L197.919 278.205L199.19 278.523C198.963 279.022 198.464 279.385 197.874 279.385Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.552,
    y: 277.971,
    width: 2.05057,
    height: 1.77836,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 278,
    width: 2,
    height: 2
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M197.874 279.382C197.466 279.382 197.103 279.246 196.831 278.974L197.874 278.248C197.874 278.656 197.874 279.065 197.874 279.382Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.464,
    y: 277.971,
    width: 1.82374,
    height: 1.77836,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 290,
    width: 2,
    height: 3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M249.638 292.496C249.683 292.178 249.728 291.815 249.774 291.452L250.681 290.545C250.817 290.726 250.908 290.999 250.908 291.271C250.908 291.951 250.318 292.496 249.638 292.496Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.406,
    y: 290.178,
    width: 1.77837,
    height: 2.64033,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 291,
    width: 2,
    height: 2
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M249.637 292.493C248.957 292.493 248.367 291.949 248.367 291.268C248.367 291.223 248.367 291.178 248.367 291.178L249.728 291.495L249.774 291.45C249.728 291.813 249.683 292.176 249.637 292.493Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.091,
    y: 290.811,
    width: 2.00521,
    height: 2.0052,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 244,
    width: 3,
    height: 3
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M295.957 246.083C295.73 246.083 295.458 245.992 295.276 245.856L296.093 244.994L297.227 244.631C297.227 244.676 297.227 244.767 297.227 244.812C297.227 245.493 296.683 246.083 295.957 246.083Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.908,
    y: 244.221,
    width: 2.64034,
    height: 2.23204,
    fill: "#03C4DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_27827_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 284,
    width: 1,
    height: 2
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M224.776 285.099L224.277 284.963C224.277 284.918 224.277 284.827 224.277 284.736L224.776 284.872C224.776 284.963 224.776 285.009 224.776 285.099Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_27827_4655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.91,
    y: 284.502,
    width: 1.14324,
    height: 0.916402,
    fill: "url(#pattern7_27827_4655)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M305.928 228.184C305.895 228.184 305.861 228.181 305.828 228.176C305.692 228.153 302.447 227.558 299.356 224.323C294.26 218.99 293.635 210.701 294.008 204.686C294.027 204.375 294.284 204.131 294.591 204.131C294.599 204.131 294.607 204.131 294.615 204.131H294.62C294.637 204.131 294.695 204.132 294.79 204.132C295.977 204.132 302.073 203.957 305.511 200.502C305.618 200.395 305.769 200.334 305.928 200.334C306.088 200.334 306.239 200.395 306.345 200.502C307.801 201.964 309.892 203.011 312.56 203.613C314.689 204.095 316.542 204.132 317.059 204.132C317.17 204.132 317.232 204.131 317.24 204.129C317.251 204.129 317.26 204.129 317.268 204.129C317.574 204.129 317.83 204.373 317.848 204.685C318.221 210.699 317.596 218.989 312.5 224.321C309.409 227.556 306.164 228.15 306.028 228.175C305.994 228.181 305.961 228.183 305.927 228.183L305.928 228.184Z",
    fill: "#46F7B7"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M305.235 225.868C305.202 225.868 305.168 225.864 305.135 225.86C304.998 225.836 301.754 225.241 298.663 222.006C293.566 216.673 292.941 208.385 293.314 202.37C293.334 202.059 293.59 201.814 293.898 201.814C293.906 201.814 293.914 201.814 293.922 201.814H293.927C293.944 201.814 294.002 201.815 294.096 201.815C295.284 201.815 301.379 201.64 304.818 198.186C304.924 198.079 305.076 198.018 305.235 198.018C305.395 198.018 305.546 198.079 305.652 198.186C307.108 199.648 309.198 200.694 311.867 201.297C313.995 201.778 315.848 201.815 316.366 201.815C316.477 201.815 316.539 201.814 316.547 201.813C316.557 201.813 316.567 201.813 316.575 201.813C316.881 201.813 317.136 202.057 317.155 202.369C317.528 208.383 316.903 216.672 311.807 222.005C308.715 225.24 305.471 225.834 305.334 225.858C305.301 225.864 305.267 225.867 305.234 225.867L305.235 225.868Z",
    fill: "#4C64ED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M304.291 215.369C304.085 215.369 303.891 215.289 303.746 215.143L301.297 212.683C301.151 212.537 301.07 212.342 301.07 212.135C301.07 211.929 301.15 211.734 301.297 211.588C301.442 211.442 301.635 211.36 301.842 211.36C302.049 211.36 302.242 211.44 302.387 211.588L304.292 213.5L308.646 209.127C308.791 208.98 308.985 208.9 309.191 208.9C309.396 208.9 309.59 208.98 309.736 209.128C309.881 209.274 309.961 209.469 309.961 209.675C309.961 209.882 309.881 210.077 309.735 210.223L304.836 215.144C304.69 215.29 304.496 215.372 304.291 215.372V215.369Z",
    fill: "#2530B5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.3412 356.603C45.9036 356.603 43.106 353.794 43.1036 350.341L43.0586 251.147C43.0586 250.055 43.4814 249.03 44.2495 248.258L49.0259 243.46C49.794 242.688 50.8151 242.264 51.9021 242.264H116.768C120.206 242.264 123.004 245.073 123.006 248.526L123.049 350.335C123.049 352.01 122.401 353.583 121.222 354.768C120.044 355.952 118.478 356.603 116.811 356.603H49.3412Z",
    fill: "url(#paint8_linear_27827_4655)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.007 248.526C123.006 245.073 120.207 242.264 116.769 242.264H51.9031C50.8161 242.264 49.795 242.688 49.0269 243.46L44.2505 248.258C43.4823 249.03 43.0596 250.055 43.0596 251.147L43.1046 350.341C43.1058 353.794 45.9046 356.603 49.3422 356.603H116.813C118.48 356.603 120.046 355.951 121.225 354.768C122.403 353.584 123.051 352.01 123.051 350.335L123.008 248.526H123.007ZM44.5774 248.586L49.3538 243.788C50.0341 243.105 50.9397 242.728 51.9031 242.728H116.769C119.953 242.728 122.543 245.329 122.545 248.526L122.548 256.188H43.5239L43.5216 251.147C43.5216 250.179 43.897 249.271 44.5774 248.586ZM120.897 354.439C119.806 355.536 118.355 356.139 116.812 356.139H49.3411C46.1576 356.139 43.5678 353.538 43.5655 350.341L43.5228 256.652H122.547L122.586 350.336C122.586 351.887 121.987 353.344 120.895 354.44L120.897 354.439Z",
    fill: "url(#paint9_linear_27827_4655)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6078 250.849C52.3733 250.849 52.9939 250.226 52.9939 249.457C52.9939 248.688 52.3733 248.064 51.6078 248.064C50.8423 248.064 50.2217 248.688 50.2217 249.457C50.2217 250.226 50.8423 250.849 51.6078 250.849Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3842 250.849C58.1497 250.849 58.7703 250.226 58.7703 249.457C58.7703 248.688 58.1497 248.064 57.3842 248.064C56.6186 248.064 55.998 248.688 55.998 249.457C55.998 250.226 56.6186 250.849 57.3842 250.849Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1596 250.849C63.9251 250.849 64.5457 250.226 64.5457 249.457C64.5457 248.688 63.9251 248.064 63.1596 248.064C62.394 248.064 61.7734 248.688 61.7734 249.457C61.7734 250.226 62.394 250.849 63.1596 250.849Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2878 337.636C58.2878 339.163 57.0449 340.411 55.5247 340.411C54.0046 340.411 52.7617 339.163 52.7617 337.636V332.086C52.7617 330.559 54.0046 329.311 55.5247 329.311C57.0449 329.311 58.2878 330.559 58.2878 332.086V337.636Z",
    fill: "url(#paint10_linear_27827_4655)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3366 337.637C69.3366 339.164 68.0937 340.413 66.5736 340.413C65.0534 340.413 63.8105 339.164 63.8105 337.637V323.762C63.8105 322.235 65.0534 320.986 66.5736 320.986C68.0937 320.986 69.3366 322.235 69.3366 323.762V337.637Z",
    fill: "url(#paint11_linear_27827_4655)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3883 337.636C80.3883 339.163 79.1454 340.412 77.6253 340.412C76.1052 340.412 74.8623 339.163 74.8623 337.636V318.211C74.8623 316.684 76.1052 315.436 77.6253 315.436C79.1454 315.436 80.3883 316.684 80.3883 318.211V337.636Z",
    fill: "url(#paint12_linear_27827_4655)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.489 337.633C102.489 339.16 101.246 340.409 99.7259 340.409C98.2058 340.409 96.9629 339.16 96.9629 337.633V293.192C96.9629 291.665 98.2058 290.416 99.7259 290.416C101.246 290.416 102.489 291.665 102.489 293.192V337.633Z",
    fill: "url(#paint13_linear_27827_4655)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.538 337.633C113.538 339.16 112.295 340.409 110.775 340.409C109.255 340.409 108.012 339.16 108.012 337.633V271.238C108.012 269.711 109.255 268.463 110.775 268.463C112.295 268.463 113.538 269.711 113.538 271.238V337.633Z",
    fill: "url(#paint14_linear_27827_4655)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4382 337.634C91.4382 339.161 90.1952 340.409 88.6751 340.409C87.155 340.409 85.9121 339.161 85.9121 337.634V304.293C85.9121 302.766 87.155 301.518 88.6751 301.518C90.1952 301.518 91.4382 302.766 91.4382 304.293V337.634Z",
    fill: "url(#paint15_linear_27827_4655)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9371 293.301C59.0758 293.301 56.3694 292.195 54.3168 290.187C52.2607 288.177 51.0871 285.481 51.0143 282.599C50.8607 276.545 55.6382 271.496 61.6644 271.341C61.7592 271.339 61.8539 271.338 61.9486 271.338C64.8098 271.338 67.5162 272.444 69.5689 274.451C71.6249 276.462 72.7985 279.157 72.8713 282.04C72.9464 284.972 71.8791 287.758 69.8669 289.883C67.8558 292.009 65.1402 293.222 62.2212 293.296C62.1265 293.298 62.0318 293.299 61.9371 293.299V293.301Z",
    fill: "#D8D8D8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0777 290.426C58.2165 290.426 55.5101 289.32 53.4574 287.312C51.4013 285.302 50.2277 282.606 50.155 279.724C50.0013 273.67 54.7789 268.621 60.8051 268.466C60.8998 268.464 60.9945 268.463 61.0892 268.463C63.9504 268.463 66.6569 269.569 68.7095 271.576C70.7656 273.587 71.9392 276.282 72.0119 279.165C72.087 282.097 71.0197 284.883 69.0075 287.008C66.9965 289.134 64.2808 290.347 61.3618 290.421C61.2671 290.423 61.1724 290.424 61.0777 290.424V290.426Z",
    fill: "#155DFC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6775 279.981C63.1889 279.515 62.4381 279.114 61.4343 278.787C60.8382 278.535 60.4432 278.303 60.2284 278.08C60.0043 277.848 59.8911 277.537 59.8911 277.156C59.8911 276.748 59.9973 276.419 60.2064 276.173C60.4201 275.923 60.762 275.796 61.2241 275.796C61.6861 275.796 62.0107 275.944 62.259 276.238C62.4843 276.506 62.6056 276.879 62.6229 277.352H64.3706C64.3694 276.57 64.1499 275.925 63.7179 275.434C63.2721 274.927 62.6448 274.613 61.8524 274.503H61.8467V273.01H60.7759V274.485C59.9569 274.57 59.3008 274.852 58.826 275.322C58.3513 275.792 58.111 276.406 58.111 277.146C58.111 277.95 58.3501 278.58 58.8226 279.02C59.3077 279.472 60.0666 279.873 61.0831 280.217C61.6526 280.436 62.0407 280.66 62.2694 280.901C62.5028 281.149 62.6217 281.48 62.6217 281.884C62.6217 282.288 62.497 282.625 62.2521 282.867C62.0072 283.107 61.6422 283.229 61.1663 283.229C60.6904 283.229 60.2838 283.093 59.9777 282.826C59.6878 282.572 59.5318 282.159 59.5133 281.597H57.7657C57.7622 282.508 58.0244 283.208 58.5477 283.678C59.0906 284.165 59.794 284.451 60.6407 284.527V285.885H61.7115V284.528H61.7161C62.5455 284.444 63.2074 284.167 63.6833 283.708C64.1546 283.252 64.3925 282.634 64.3925 281.871C64.3925 281.109 64.1499 280.435 63.6729 279.98L63.6775 279.981Z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0832 288.555C56.0828 288.555 52.0156 284.469 52.0156 279.446C52.0156 274.423 56.0828 270.338 61.0832 270.338C66.0837 270.338 70.1508 274.423 70.1508 279.446C70.1508 284.469 66.0837 288.555 61.0832 288.555ZM61.0832 270.802C56.338 270.802 52.4777 274.68 52.4777 279.446C52.4777 284.213 56.338 288.091 61.0832 288.091C65.8284 288.091 69.6888 284.213 69.6888 279.446C69.6888 274.68 65.8284 270.802 61.0832 270.802Z",
    fill: "#B5B5B5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9077 298.844H51.2604C50.8781 298.844 50.5674 298.531 50.5674 298.147C50.5674 297.763 50.8781 297.451 51.2604 297.451H70.9077C71.29 297.451 71.6007 297.763 71.6007 298.147C71.6007 298.531 71.29 298.844 70.9077 298.844Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2048 303.023H51.2604C50.8781 303.023 50.5674 302.711 50.5674 302.327C50.5674 301.943 50.8781 301.631 51.2604 301.631H61.2048C61.5871 301.631 61.8978 301.943 61.8978 302.327C61.8978 302.711 61.5871 303.023 61.2048 303.023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2105 303.023H64.6589C64.2765 303.023 63.9658 302.711 63.9658 302.327C63.9658 301.943 64.2765 301.631 64.6589 301.631H67.2105C67.5929 301.631 67.9036 301.943 67.9036 302.327C67.9036 302.711 67.5929 303.023 67.2105 303.023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.871 269.191C325.433 269.191 322.635 266.382 322.633 262.929L322.588 201.03C322.588 199.938 323.011 198.912 323.779 198.141L328.555 193.343C329.323 192.571 330.344 192.146 331.431 192.146H397.627C401.065 192.146 403.862 194.956 403.865 198.409L403.908 262.924C403.908 264.598 403.26 266.172 402.081 267.356C400.903 268.54 399.337 269.192 397.67 269.192H328.869L328.871 269.191Z",
    fill: "url(#paint16_linear_27827_4655)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M370.185 243.306H365.138V246.304C365.349 246.023 365.66 245.787 366.072 245.596C366.494 245.405 366.941 245.31 367.413 245.31C368.257 245.31 368.94 245.49 369.462 245.852C369.994 246.214 370.371 246.671 370.592 247.223C370.823 247.776 370.939 248.358 370.939 248.971C370.939 249.714 370.793 250.377 370.502 250.96C370.22 251.533 369.794 251.985 369.221 252.316C368.658 252.648 367.965 252.813 367.142 252.813C366.047 252.813 365.168 252.542 364.505 252C363.842 251.457 363.445 250.739 363.314 249.845H364.987C365.097 250.317 365.344 250.694 365.725 250.975C366.107 251.246 366.584 251.382 367.157 251.382C367.87 251.382 368.402 251.166 368.754 250.734C369.116 250.302 369.296 249.729 369.296 249.016C369.296 248.293 369.116 247.741 368.754 247.359C368.392 246.967 367.86 246.771 367.157 246.771C366.665 246.771 366.248 246.897 365.906 247.148C365.575 247.389 365.334 247.72 365.183 248.142H363.556V241.799H370.185V243.306Z",
    fill: "#55B9F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M359.342 244.374C359.232 243.912 359.031 243.566 358.739 243.335C358.448 243.104 358.041 242.988 357.519 242.988C356.725 242.988 356.133 243.294 355.741 243.907C355.349 244.51 355.143 245.514 355.123 246.921C355.384 246.479 355.766 246.137 356.268 245.896C356.771 245.655 357.313 245.535 357.896 245.535C358.559 245.535 359.141 245.68 359.643 245.971C360.156 246.253 360.553 246.665 360.834 247.207C361.125 247.749 361.271 248.397 361.271 249.151C361.271 249.854 361.13 250.482 360.849 251.034C360.578 251.587 360.171 252.024 359.628 252.345C359.086 252.657 358.433 252.812 357.67 252.812C356.635 252.812 355.821 252.586 355.229 252.134C354.646 251.672 354.234 251.024 353.993 250.19C353.762 249.357 353.646 248.317 353.646 247.071C353.646 243.395 354.942 241.557 357.534 241.557C358.538 241.557 359.327 241.828 359.9 242.37C360.482 242.913 360.824 243.581 360.924 244.374H359.342ZM357.519 246.981C356.906 246.981 356.384 247.167 355.952 247.539C355.53 247.9 355.319 248.428 355.319 249.121C355.319 249.814 355.515 250.366 355.907 250.778C356.308 251.18 356.866 251.381 357.579 251.381C358.212 251.381 358.709 251.185 359.071 250.793C359.443 250.401 359.628 249.879 359.628 249.226C359.628 248.543 359.448 248.001 359.086 247.599C358.734 247.187 358.212 246.981 357.519 246.981Z",
    fill: "#55B9F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M399.53 253.177H390.087C390.087 238.354 378.126 226.339 363.371 226.339C348.616 226.339 336.654 238.354 336.654 253.177H327.211C327.211 233.116 343.401 216.854 363.371 216.854C383.341 216.854 399.53 233.116 399.53 253.177Z",
    fill: "#3131BF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M392.5 231.032C389.822 232.925 387.144 234.819 384.466 236.711C383.581 235.576 376.042 226.228 363.37 226.339C351.91 226.44 344.886 234.201 343.296 236.073C337.449 242.958 336.77 250.645 336.654 253.177H327.211C327.232 250.228 327.655 238.859 336.367 229.019C346.856 217.174 361.103 216.865 363.37 216.854C380.84 216.771 391.222 229.419 392.5 231.031V231.032Z",
    fill: "#55B9F5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M403.865 198.409C403.864 194.956 401.066 192.146 397.627 192.146H331.431C330.346 192.146 329.323 192.571 328.555 193.343L323.779 198.141C323.011 198.912 322.588 199.938 322.588 201.03L322.633 262.929C322.634 266.382 325.433 269.191 328.871 269.191H397.671C399.338 269.191 400.904 268.539 402.082 267.355C403.261 266.172 403.909 264.597 403.909 262.923L403.866 198.408L403.865 198.409ZM324.106 198.47L328.882 193.672C329.562 192.989 330.468 192.612 331.431 192.612H397.627C400.811 192.612 403.4 195.213 403.403 198.411L403.407 206.072H323.053L323.05 201.031C323.05 200.063 323.425 199.155 324.106 198.47ZM401.756 267.028C400.665 268.125 399.214 268.728 397.671 268.728H328.871C325.688 268.728 323.097 266.127 323.095 262.93L323.053 206.535H403.407L403.444 262.924C403.444 264.474 402.845 265.932 401.753 267.028H401.756Z",
    fill: "url(#paint17_linear_27827_4655)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M331.136 200.732C331.902 200.732 332.522 200.109 332.522 199.34C332.522 198.571 331.902 197.947 331.136 197.947C330.371 197.947 329.75 198.571 329.75 199.34C329.75 200.109 330.371 200.732 331.136 200.732Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M336.912 200.732C337.677 200.732 338.298 200.109 338.298 199.34C338.298 198.571 337.677 197.947 336.912 197.947C336.146 197.947 335.525 198.571 335.525 199.34C335.525 200.109 336.146 200.732 336.912 200.732Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M342.687 200.732C343.452 200.732 344.073 200.109 344.073 199.34C344.073 198.571 343.452 197.947 342.687 197.947C341.921 197.947 341.301 198.571 341.301 199.34C341.301 200.109 341.921 200.732 342.687 200.732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.518 195.614C43.0804 195.614 40.2827 192.805 40.2804 189.351L40.2354 171.382C40.2354 170.29 40.6581 169.264 41.4263 168.492L46.2026 163.694C46.9708 162.923 47.9919 162.498 49.0789 162.498H108.401C111.838 162.498 114.636 165.307 114.638 168.76L114.681 189.347C114.681 191.021 114.033 192.596 112.855 193.779C111.676 194.963 110.11 195.615 108.443 195.615H46.5168L46.518 195.614Z",
    fill: "url(#paint18_linear_27827_4655)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M108.444 195.614H46.518C43.0804 195.614 40.2827 192.805 40.2804 189.351L40.2354 171.382C40.2354 170.29 40.6581 169.264 41.4263 168.492L46.2026 163.694C46.9708 162.923 47.9919 162.498 49.0789 162.498H108.401C111.838 162.498 114.636 165.307 114.638 168.76L114.681 189.347C114.681 191.021 114.033 192.596 112.855 193.779C111.676 194.963 110.11 195.615 108.443 195.615L108.444 195.614ZM49.0789 162.96C48.1155 162.96 47.211 163.337 46.5295 164.02L41.7532 168.818C41.0728 169.502 40.6974 170.411 40.6974 171.379L40.7424 189.349C40.7436 192.547 43.3345 195.148 46.518 195.148H108.444C109.988 195.148 111.439 194.545 112.529 193.449C113.619 192.352 114.22 190.895 114.22 189.345L114.177 168.758C114.176 165.56 111.585 162.959 108.402 162.959H49.08L49.0789 162.96Z",
    fill: "url(#paint19_linear_27827_4655)"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9911 171.293H48.3796C47.9972 171.293 47.6865 170.981 47.6865 170.597C47.6865 170.213 47.9972 169.9 48.3796 169.9H78.9911C79.3735 169.9 79.6842 170.213 79.6842 170.597C79.6842 170.981 79.3735 171.293 78.9911 171.293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M106.714 171.293H84.6501C84.2678 171.293 83.957 170.981 83.957 170.597C83.957 170.213 84.2678 169.9 84.6501 169.9H106.714C107.096 169.9 107.407 170.213 107.407 170.597C107.407 170.981 107.096 171.293 106.714 171.293Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4425 175.472H48.3796C47.9972 175.472 47.6865 175.16 47.6865 174.776C47.6865 174.392 47.9972 174.08 48.3796 174.08H96.4425C96.8248 174.08 97.1356 174.392 97.1356 174.776C97.1356 175.16 96.8248 175.472 96.4425 175.472Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67.44 179.652H48.3796C47.9972 179.652 47.6865 179.34 47.6865 178.956C47.6865 178.572 47.9972 178.26 48.3796 178.26H67.44C67.8224 178.26 68.1331 178.572 68.1331 178.956C68.1331 179.34 67.8224 179.652 67.44 179.652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M103.006 183.828H48.3786C47.9963 183.828 47.6855 183.516 47.6855 183.132C47.6855 182.748 47.9963 182.436 48.3786 182.436H103.006C103.388 182.436 103.699 182.748 103.699 183.132C103.699 183.516 103.388 183.828 103.006 183.828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2049 188.008H48.3796C47.9972 188.008 47.6865 187.695 47.6865 187.311C47.6865 186.927 47.9972 186.615 48.3796 186.615H90.2049C90.5873 186.615 90.898 186.927 90.898 187.311C90.898 187.695 90.5873 188.008 90.2049 188.008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M101.063 188.008H94.1218C93.7394 188.008 93.4287 187.695 93.4287 187.311C93.4287 186.927 93.7394 186.615 94.1218 186.615H101.063C101.445 186.615 101.756 186.927 101.756 187.311C101.756 187.695 101.445 188.008 101.063 188.008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M106.714 179.652H72.8679C72.4855 179.652 72.1748 179.34 72.1748 178.956C72.1748 178.572 72.4855 178.26 72.8679 178.26H106.714C107.096 178.26 107.407 178.572 107.407 178.956C107.407 179.34 107.096 179.652 106.714 179.652Z",
    fill: "white"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1073 205.517C74.7497 205.517 72.5192 204.606 70.827 202.952C69.1324 201.295 68.1656 199.073 68.1055 196.697C67.9785 191.708 71.9162 187.546 76.8832 187.42C76.9617 187.417 77.0391 187.416 77.1165 187.416C79.4741 187.416 81.7046 188.327 83.3969 189.981C85.0914 191.638 86.0582 193.86 86.1183 196.236C86.1795 198.653 85.3005 200.949 83.6429 202.701C81.9853 204.453 79.7467 205.452 77.3418 205.514C77.2632 205.516 77.1858 205.517 77.1085 205.517H77.1073Z",
    fill: "#D8D8D8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4139 203.197C74.0564 203.197 71.8258 202.286 70.1336 200.631C68.4391 198.974 67.4722 196.752 67.4122 194.377C67.2851 189.388 71.2229 185.226 76.1898 185.099C76.2684 185.097 76.3458 185.096 76.4232 185.096C78.7807 185.096 81.0113 186.007 82.7035 187.661C84.398 189.318 85.3649 191.54 85.4249 193.915C85.4862 196.332 84.6071 198.629 82.9495 200.381C81.292 202.133 79.0533 203.132 76.6484 203.193C76.5699 203.196 76.4925 203.197 76.4151 203.197H76.4139Z",
    fill: "#155DFC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5561 194.583C78.1542 194.199 77.5339 193.868 76.708 193.599C76.2159 193.391 75.8913 193.2 75.7146 193.016C75.5309 192.825 75.4374 192.568 75.4374 192.254C75.4374 191.919 75.5251 191.646 75.6973 191.444C75.8728 191.239 76.1547 191.134 76.5359 191.134C76.917 191.134 77.1839 191.257 77.3895 191.499C77.5755 191.719 77.676 192.028 77.6887 192.416H79.1291C79.1291 191.772 78.9477 191.241 78.592 190.836C78.2246 190.418 77.7071 190.159 77.0545 190.069H77.0499V188.838H76.1674V190.054C75.4928 190.125 74.9522 190.357 74.5606 190.744C74.1702 191.132 73.9715 191.638 73.9715 192.248C73.9715 192.911 74.169 193.43 74.5583 193.792C74.958 194.164 75.5829 194.496 76.4215 194.779C76.8905 194.96 77.2104 195.144 77.3999 195.344C77.5928 195.548 77.6898 195.821 77.6898 196.154C77.6898 196.487 77.587 196.764 77.386 196.964C77.1839 197.162 76.8835 197.263 76.4908 197.263C76.0981 197.263 75.7631 197.152 75.5113 196.931C75.2722 196.721 75.144 196.381 75.1289 195.918H73.6885C73.6851 196.669 73.9022 197.246 74.3331 197.633C74.7801 198.035 75.3611 198.27 76.0588 198.333V199.451H76.9413V198.334H76.9448C77.6286 198.264 78.1738 198.037 78.5654 197.658C78.9535 197.282 79.1499 196.772 79.1499 196.143C79.1499 195.514 78.95 194.96 78.5573 194.584L78.5561 194.583Z",
    fill: "#757575"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.418 201.577C72.3381 201.577 69.0195 198.243 69.0195 194.145C69.0195 190.047 72.3381 186.713 76.418 186.713C80.4978 186.713 83.8165 190.047 83.8165 194.145C83.8165 198.243 80.4978 201.577 76.418 201.577ZM76.418 186.945C72.4664 186.945 69.2506 190.174 69.2506 194.145C69.2506 198.115 72.4664 201.345 76.418 201.345C80.3696 201.345 83.5854 198.114 83.5854 194.145C83.5854 190.175 80.3696 186.945 76.418 186.945Z",
    fill: "#0A2B74"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M142.307 197.203C138.869 197.203 136.072 194.394 136.069 190.941L136.024 180.397C136.024 179.305 136.447 178.28 137.215 177.508L141.992 172.71C142.76 171.938 143.781 171.514 144.868 171.514H186.356C189.794 171.514 192.591 174.323 192.594 177.776L192.636 190.936C192.636 192.611 191.988 194.185 190.81 195.369C189.632 196.552 188.066 197.204 186.399 197.204H142.307V197.203Z",
    fill: "url(#paint20_linear_27827_4655)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M186.399 197.203H142.307C138.869 197.203 136.072 194.394 136.069 190.941L136.024 180.397C136.024 179.305 136.447 178.28 137.215 177.508L141.992 172.71C142.76 171.938 143.781 171.514 144.868 171.514H186.356C189.794 171.514 192.591 174.323 192.594 177.776L192.636 190.936C192.636 192.611 191.988 194.185 190.81 195.369C189.632 196.552 188.066 197.204 186.399 197.204V197.203ZM144.869 171.977C143.906 171.977 143.001 172.354 142.32 173.037L137.543 177.835C136.863 178.519 136.488 179.428 136.488 180.396L136.533 190.94C136.534 194.138 139.125 196.739 142.308 196.739H186.4C187.943 196.739 189.394 196.136 190.484 195.039C191.575 193.943 192.175 192.485 192.175 190.935L192.133 177.775C192.132 174.577 189.541 171.975 186.357 171.975H144.869V171.977Z",
    fill: "url(#paint21_linear_27827_4655)"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M149.91 186.803C152.748 186.803 155.757 188.392 156.173 191.32C157.469 189.843 158.256 187.904 158.256 185.78C158.256 181.15 154.519 177.396 149.91 177.396C145.301 177.396 141.564 181.15 141.564 185.78C141.564 187.903 142.351 189.843 143.647 191.32C144.063 188.392 147.072 186.803 149.91 186.803ZM149.91 179.997C151.608 179.997 152.985 181.38 152.985 183.086C152.985 184.791 151.608 186.174 149.91 186.174C148.212 186.174 146.835 184.791 146.835 183.086C146.835 181.38 148.212 179.997 149.91 179.997Z",
    fill: "#155DFC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M186.328 180.875H164.033C163.651 180.875 163.34 180.563 163.34 180.179C163.34 179.795 163.651 179.482 164.033 179.482H186.328C186.71 179.482 187.021 179.795 187.021 180.179C187.021 180.563 186.71 180.875 186.328 180.875Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M170.964 183.658H186.328C186.71 183.658 187.021 183.97 187.021 184.354C187.021 184.738 186.71 185.051 186.328 185.051H170.964C170.581 185.051 170.271 184.738 170.271 184.354C170.271 183.97 170.581 183.658 170.964 183.658Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M164.033 183.658H167.846C168.228 183.658 168.539 183.97 168.539 184.354C168.539 184.738 168.228 185.051 167.846 185.051H164.033C163.651 185.051 163.34 184.738 163.34 184.354C163.34 183.97 163.651 183.658 164.033 183.658Z",
    fill: "white"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M176.163 189.23H164.033C163.651 189.23 163.34 188.918 163.34 188.534C163.34 188.15 163.651 187.838 164.033 187.838H176.163C176.545 187.838 176.856 188.15 176.856 188.534C176.856 188.918 176.545 189.23 176.163 189.23Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M182.4 189.23H179.511C179.129 189.23 178.818 188.918 178.818 188.534C178.818 188.15 179.129 187.838 179.511 187.838H182.4C182.783 187.838 183.093 188.15 183.093 188.534C183.093 188.918 182.783 189.23 182.4 189.23Z",
    fill: "white"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M299.987 327.589C299.987 305.806 317.646 288.146 339.43 288.146V288.146C361.214 288.146 378.873 305.806 378.873 327.589V327.589C378.873 349.373 361.214 367.032 339.43 367.032V367.032C317.646 367.032 299.987 349.373 299.987 327.589V327.589Z",
    fill: "#00D694"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.666 327.589C307.666 310.046 321.887 295.824 339.43 295.824V295.824C356.973 295.824 371.195 310.046 371.195 327.589V327.589C371.195 345.132 356.973 359.354 339.43 359.354V359.354C321.887 359.354 307.666 345.132 307.666 327.589V327.589Z",
    fill: "#CDF9F1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 315.43,
    y: 302.883,
    width: 48.7059,
    height: 48.7059,
    rx: 24.3529,
    fill: "#CDF9F1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.43 341.352C347.227 341.352 353.548 335.032 353.548 327.235C353.548 319.438 347.227 313.117 339.43 313.117C331.633 313.117 325.312 319.438 325.312 327.235C325.312 335.032 331.633 341.352 339.43 341.352ZM345.913 323.65C346.272 323.188 346.189 322.523 345.727 322.164C345.266 321.805 344.6 321.888 344.241 322.35L338.584 329.623C338.459 329.784 338.222 329.805 338.07 329.668L334.491 326.448C334.057 326.057 333.387 326.092 332.996 326.527C332.605 326.961 332.64 327.631 333.075 328.022L336.653 331.242C337.719 332.202 339.376 332.055 340.256 330.923L345.913 323.65Z",
    fill: "#00D694"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M322.563 162.164C322.563 155.632 317.515 150.331 311.294 150.331C317.515 150.331 322.563 145.03 322.563 138.498C322.563 145.03 327.612 150.331 333.833 150.331C327.612 150.331 322.563 155.632 322.563 162.164Z",
    fill: "#46F7B7"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M364.916 321.695C364.916 315.163 359.867 309.862 353.646 309.862C359.867 309.862 364.916 304.561 364.916 298.029C364.916 304.561 369.964 309.862 376.185 309.862C369.964 309.862 364.916 315.163 364.916 321.695Z",
    fill: "#46F7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27827_4655",
    transform: "scale(0.0263158 0.0454545)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_27827_4655",
    transform: "scale(0.00431034 0.00970874)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_27827_4655",
    transform: "scale(0.0227273 0.047619)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_27827_4655",
    transform: "scale(0.0322581 0.00636943)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_27827_4655",
    transform: "scale(0.111111 0.0227273)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_27827_4655",
    transform: "scale(0.0144928 0.05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_27827_4655",
    transform: "scale(0.0147059 0.05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_27827_4655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_27827_4655",
    transform: "scale(0.2 0.25)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27827_4655",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-294.973 660.57 -1579.77 -642.035 265.695 192.494)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#100B3B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27827_4655",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7047 358.166) rotate(-83.7882) scale(1.00762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A55FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B38C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27827_4655",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6082 361.251) scale(2.5886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A55FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27827_4655",
    x1: 156.792,
    y1: 298.894,
    x2: 158.416,
    y2: 300.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27827_4655",
    x1: 176.693,
    y1: 264.372,
    x2: 177.835,
    y2: 265.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27827_4655",
    x1: 197.224,
    y1: 264.372,
    x2: 198.366,
    y2: 265.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27827_4655",
    x1: 154.531,
    y1: 292.05,
    x2: 156.004,
    y2: 293.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27827_4655",
    x1: 27.9892,
    y1: 353.463,
    x2: 31.3296,
    y2: 357.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_27827_4655",
    x1: 116.558,
    y1: 357.723,
    x2: 49.9011,
    y2: 242.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_27827_4655",
    x1: 116.558,
    y1: 357.723,
    x2: 49.9009,
    y2: 242.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_27827_4655",
    x1: 52.9488,
    y1: 339.344,
    x2: 58.1367,
    y2: 330.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_27827_4655",
    x1: 62.2038,
    y1: 338.304,
    x2: 71.0049,
    y2: 323.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_27827_4655",
    x1: 72.0589,
    y1: 337.609,
    x2: 83.2684,
    y2: 318.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27827_4655",
    x1: 99.7259,
    y1: 340.407,
    x2: 99.7259,
    y2: 290.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#72C1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#87C8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#93CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_27827_4655",
    x1: 110.776,
    y1: 153.277,
    x2: 110.776,
    y2: 268.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#72C1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#87C8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#93CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_27827_4655",
    x1: 88.6763,
    y1: 153.278,
    x2: 88.6763,
    y2: 301.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#72C1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#87C8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#93CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_27827_4655",
    x1: 388.88,
    y1: 275.262,
    x2: 338.074,
    y2: 187.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_27827_4655",
    x1: 388.88,
    y1: 275.263,
    x2: 338.074,
    y2: 187.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_27827_4655",
    x1: 92.7627,
    y1: 205.681,
    x2: 62.7509,
    y2: 153.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_27827_4655",
    x1: 92.7627,
    y1: 205.681,
    x2: 62.7509,
    y2: 153.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_27827_4655",
    x1: 175.805,
    y1: 204.32,
    x2: 153.505,
    y2: 165.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_27827_4655",
    x1: 171.152,
    y1: 203.184,
    x2: 157.754,
    y2: 166.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27827_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 437,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27827_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369.882,
    height: 253.412,
    fill: "white",
    transform: "translate(43.0586 120.854)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_27827_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.294,
    height: 151.059,
    fill: "white",
    transform: "translate(144 174.494)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_27827_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264.94,
    height: 176.657,
    fill: "white",
    transform: "translate(44.4902 168.279)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_27827_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264.94,
    height: 176.657,
    fill: "white",
    transform: "translate(44.4902 168.279)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_27827_4655",
    width: 38,
    height: 22,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_27827_4655",
    width: 232,
    height: 103,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOgAAABnCAYAAAAKTw51AAADzUlEQVR4AezdUXLbIBAGYEZ36lPP0fsfhTL1a2XjCfYuy9dEeYg1Ar7lh4yiuNfvX3+6g4E5kHMOXM0/AgTSCgho2tLoGIHWBNQsIJBYQEDjiqNlAi8FrtZ7czAwB3LOATvoyzXMCQTiBAQ0zl7LBF4KCOhLIicUFNhmSAK6Tal09EQBAT2x6sa8jYCAblMqHT1R4OrNBwECWQUK7qAnrrPGXFVAQKtW1rhKCAhoiTIaRFUBAa1aWeMqISCgJcqYZRD6sVpAQFeLuh6BhQICuhDTpQisFrj8tZm/tjMH8s4BO+jqJc/1CCwUmA/owkZdigCBOQEBnXNyFoEQAQENYdcogTkB70nkDkneOyRq420359ax4LM0f6yAH3GPLb2B7yAgoDtUSR+PFRDQY0tv4DsICOgOVdLHOIHglgU0uACaJ/BMwHsSeU8mAokF7KDPli+vEQgWENDgAmiewDOBowP6DMZrBDIICGiGKugDgRsBAb2B8W0CGQQENEMV9IHAjYCA3sD49mcFXH1O4Oq9NwcDcyDnHLCDzi1kziIQIiCgIewaJTAnIKBzTs4iECLwiYCGDESjBCoKCGjFqhpTGQEBLVNKA6kocPUxKkdrDBhknAN20LFAFfo0lGICAlqsoIZTS0BAa9XTaIoJCGixghpOLQH/9UMftwYc4w4Rh/azefARQztorQXXaIoJCGixghpOLQEBrVVPoykmIKDFCmo4tQQEdKqeTiIQIyCgMe5aJTAlIKBTTE4iECNw9eaDAIGsAnbQmIVRq9MCZ58ooGfX3+iTCwho8gLp3tkCAnp2/Y0+ucA17hE1x6hSd5gH+eZA7A46PHwSIHAv4NcsY9vIeotdvwjYQe8XL68QCBcQ0PAS6ACBewEBvbep/YrRbSEgoFuUSSdPFRDQUytv3FsICOgWZdLJUwUE9NTKG3ecwBstC+gbWE4l8G0BAf22uPYIvCHgWVzP4HoWO/EcsIO+sZo5lcC3BQR0sbjLEVgp4GF5D8sTSCxgB1253LkWgcUCAroY1OUIrBQQ0JWarhUqULFxAa1YVWMqIyCgZUppIBUFBLRiVY2pjMAIaOLHKMbtb4+5qM/Jc2AEdIvFRicJHCkgoEeW3aB3Ebj6+AnKMX6I4tDMg3zzwA66y1Kqn0cKjICOrcPNmFF8DmP/+J+D7wXmYwR0+PskQCClgICmLItOEXgICOjDwVcCKQUENGVZdIrAP4EmoA8HXwmkFBDQlGXRKQIPAQF9OPhKIKXA5bd/fvtnDuSdA3bQsHVTwwReCwjoayNnEAgT+AsAAP//a4axCwAAAAZJREFUAwC2j8m8vP21NQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_27827_4655",
    width: 44,
    height: 21,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_27827_4655",
    width: 31,
    height: 157,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_27827_4655",
    width: 9,
    height: 44,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAsCAYAAAC38JKVAAAGZ0lEQVR4nAFcBqP5AFRNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/wBUTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/8AVE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/AFRNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/wBUTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/8AVE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/AFRNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/1RNa/9UTWv/VE1r/wBTTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/8AU0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/AFNMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/wBTTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/8AU0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/AFNMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/wBTTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/9TTGv/U0xr/1NMa/8AUktq/1JLav9SS2r/Uktq/1JLav9SS2r/Uktq/1JLav9SS2r/AFJLav9SS2r/Uktq/1JLav9SS2r/Uktq/1JLav9SS2r/Uktq/wBSS2r/Uktq/1JLav9SS2r/Uktq/1JLav9SS2r/Uktq/1JLav8AUktq/1JLav9SS2r/Uktq/1JLav9SS2r/Uktq/1JLav9SS2r/AFJLav9SS2r/Uktq/1JLav9SS2r/Uktq/1JLav9SS2r/Uktq/wBRS2n/UUtp/1FLaf9RS2n/UUtp/1FLaf9RS2n/UUtp/1FLaf8AUUtp/1FLaf9RS2n/UUtp/1FLaf9RS2n/UUtp/1FLaf9RS2n/AFFLaf9RS2n/UUtp/1FLaf9RS2n/UUtp/1FLaf9RS2n/UUtp/wBRSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf8AUUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/AFFKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/wBRSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf8AUUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/UUpp/1FKaf9RSmn/AFBKaP9QSmj/UEpo/1BKaP9QSmj/UEpo/1BKaP9QSmj/UEpo/wBQSmj/UEpo/1BKaP9QSmj/UEpo/1BKaP9QSmj/UEpo/1BKaP8AUElo/1BJaP9QSWj/UElo/1BJaP9QSWj/UElo/1BJaP9QSWj/AFBJaP9QSWj/UElo/1BJaP9QSWj/UElo/1BJaP9QSWj/UElo/wBQSWj/UElo/1BJaP9QSWj/UElo/1BJaP9QSWj/UElo/1BJaP8AUElo/1BJaP9QSWj/UElo/1BJaP9QSWj/UElo/1BJaP9QSWj/AFBJaP9QSWj/UElo/1BJaP9QSWj/UElo/1BJaP9QSWj/UElo/wBQSGj/UEho/1BIaP9QSGj/UEho/1BIaP9QSGj/UEho/1BIaP8AUEho/1BIaP9QSGj/UEho/1BIaP9QSGj/UEho/1BIaP9QSGj/AFBIaP9QSGj/UEho/1BIaP9QSGj/UEho/1BIaP9QSGj/UEho/wBQSGj/UEho/1BIaP9QSGj/UEho/1BIaP9QSGj/UEho/1BIaP8AUEho/1BIaP9QSGj/UEho/1BIaP9QSGj/UEho/1BIaP9QSGj/AE9IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/wBPSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/8AT0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/AE9IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/wBPSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/9PSGf/T0hn/09IZ/+3bh55upzqdgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_27827_4655",
    width: 69,
    height: 20,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAUCAYAAADbX/B7AAAAeElEQVR4AezWsQ3AIAxEUctzpcsa2X8N4sYF4Xfp4EexkK7j6RDkfT3DmQ0y/BYBURaSCFFEAQGIbIooIABRjhHhzAYeH2oKZMdHNgUqIIooIACRTUGUXe/jH/uyKdgUCE+Psh604dSLtprQDh6fwvj+hdI+rt2XFwAA///xv89zAAAABklEQVQDAKUcHGvl/D3AAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_27827_4655",
    width: 68,
    height: 20,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAUCAYAAAA0nZtFAAAAdElEQVR4AezWsQ3AIBBDUevmSpc1sv8axBTRBTMCH3GF2yefoO7rGUwblDiLACALhwQIICEQkYYAEgIRawyJaQNWJhsS+fhIQ6ICgAASAhFpyAbCm9tvri0qgI6PrExUoPxRFeOtMcx0oCGG+F+DTBfm68gLAAD//z9xYwoAAAAGSURBVAMA1bYUlyb+cdUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_27827_4655",
    width: 5,
    height: 4,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAAX0lEQVR4nAFUAKv/ANSo/f/Uqf3/1Kn9/9Sp/f/Uqf3/ANOo/f/TqP3/06j9/9Oo/f/TqP3/ANOo/P/TqPz/06j9/9Oo/f/TqP3/ANOo/P/TqPz/06j8/9Oo/P/TqPz/WRJFT1etQJ0AAAAASUVORK5CYII="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmation.39b95c98a6f12bb64533f25457bcdebb.svg";